import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link, useSearchParams} from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import ImageUpload from '../../components/ImageUpload';

const AddUpdate = () => {
  
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const [isLoader, setIsLoader] = useState(false);
  const [pictureFile, setPictureFile] = useState(null);
  const [pictureUrl, setPictureUrl] = useState(null);
  const [phoneCode, setPhoneCode] = useState('+255');
  const role = searchParams.get('role'); // Get role from URL
  
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    email: '',
    phone: '',
    role: role, // Default role
    status: true,
    password: '',
    confirm_password: '',
  });

  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `admin/users/${id}`,
        data: { get_for: 'details' }
      });
      const data = response.data;
      if (data.status) {
        const userData = data.data;

        let pCode = '+255';
        let pNumber = userData.phone || '';
        if (userData.phone && userData.phone.startsWith('+')) {
             if(userData.phone.startsWith('+255')) {
                 pCode = '+255';
                 pNumber = userData.phone.substring(4);
             } else {
                 const match = userData.phone.match(/^(\+\d{1,4})(\d+)$/);
                 if (match) {
                     pCode = match[1];
                     pNumber = match[2];
                 }
             }
        }
        setPhoneCode(pCode);

        setFormData({
          name: userData.name || '',
          username: userData.username || '',
          email: userData.email || '',
          phone: pNumber,
          role: (typeof userData.role === 'object' ? userData.role?.name : userData.role) || 'admin',
          status: userData.status !== undefined ? userData.status : true,
          password: '',
          confirm_password: '',
        });
        setPictureUrl(userData.picture || null);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to load user data');
    } finally {
      setIsLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleImageChange = (name, file) => {
    if (name === 'picture') {
      setPictureFile(file);
      if (file) {
        setPictureUrl(URL.createObjectURL(file));
      } else {
        setPictureUrl(null);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!id && (!formData.password || !formData.confirm_password)) {
        toast.error('Password and Confirm Password are required');
        return;
    }

    if (formData.password && formData.password !== formData.confirm_password) {
        toast.error('Passwords do not match');
        return;
    }

    setIsLoader(true);
    try {
        const fullPhone = phoneCode + formData.phone;
        const data = new FormData();
        Object.keys(formData).forEach((key) => {
            if (key === 'phone') {
                data.append(key, fullPhone);
            } else {
                data.append(key, formData[key]);
            }
        });

        if (pictureFile) {
            data.append('picture', pictureFile);
        }

        if (id) {
            data.append('_method', 'PUT');
        }

        const response = await ApiService.request({
            method: 'POST', // Using POST for both as often used with FormData/Laravel
            url: id ? `admin/users/${id}` : 'admin/users',
            data: data,
             headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.data.status) {
            toast.success(response.data.message);
            navigate('/users?role='+role);
        } else {
            toast.error(response.data.message);
        }
    } catch (error) {
        // ApiService already shows a toast for HTTP errors (401, 422, 500, etc.)
        if (!error.response) {
            toast.error('Something went wrong');
        }
    } finally {
        setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit User' : 'Add User'}
            </h1>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3">
            <Link to={"/users?role="+role} className="btn btn-sm fw-bold btn-secondary">
              Back
            </Link>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-fluid">
          <div className="card">
            <div className="card-body py-4">
              {isLoader && !id ? (
                <Loader />
              ) : (
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-12 mb-3 text-center">
                            <ImageUpload
                                name="picture"
                                label="Profile Picture"
                                imageUrl={pictureUrl}
                                onImageChange={handleImageChange}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label required">Name</label>
                            <input
                                type="text"
                                name="name"
                                className="form-control form-control-solid"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label required">Username</label>
                            <input
                                type="text"
                                name="username"
                                className="form-control form-control-solid"
                                value={formData.username}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label ">Email</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control form-control-solid"
                                value={formData.email}
                                onChange={handleChange}
                                
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label required">Phone</label>
                            <div className="input-group">
                                <input 
                                    type="text" 
                                    className="form-control form-control-solid w-80px" 
                                    value={phoneCode}
                                    onChange={(e) => setPhoneCode(e.target.value)}
                                    placeholder="+255"
                                    style={{ maxWidth: '80px' }}
                                />
                                <input
                                    type="text"
                                    name="phone"
                                    className="form-control form-control-solid"
                                    value={formData.phone}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '');
                                        setFormData({...formData, phone: val});
                                    }}
                                    required
                                    placeholder="Phone Number"
                                />
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label required">Role</label>
                            <select
                                name="role"
                                className="form-control form-control-solid"
                                value={formData.role}
                                onChange={handleChange}
                                required
                            >
                                <option value="admin">Admin</option>
                                <option value="doctor">Doctor</option>
                                <option value="receptionist">Receptionist</option>
                                <option value="specialist">Specialist</option>
                            </select>
                        </div>

                         {!id && (
                            <>
                                <div className="col-md-6 mb-3">
                                <label className="form-label required">Password</label>
                                <input
                                    type="password"
                                    name="password"
                                    className="form-control form-control-solid"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                                </div>
                                <div className="col-md-6 mb-3">
                                <label className="form-label required">Confirm Password</label>
                                <input
                                    type="password"
                                    name="confirm_password"
                                    className="form-control form-control-solid"
                                    value={formData.confirm_password}
                                    onChange={handleChange}
                                    required
                                />
                                </div>
                            </>
                        )}

                        <div className="col-md-6 mb-3">
                            <label className="form-check form-check-custom form-check-solid form-check-inline mt-8">
                                <input
                                className="form-check-input"
                                type="checkbox"
                                name="status"
                                checked={formData.status}
                                onChange={handleChange}
                                />
                                <span className="form-check-label fw-bold text-gray-700 fs-6">Active Status</span>
                            </label>
                        </div>
                    </div>

                  <div className="d-flex justify-content-end mt-4">
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      {isLoader ? 'Saving...' : 'Save Changes'}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdate;
